import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { DialogClose } from './DialogFrame/DialogClose';

type Props = {
  name: string | React.ReactNode; // Name of the resource that going to be delete
  isPermanent?: boolean;
  onDelete: () => void;
  onCancel: () => void;
  customComponent?: React.ReactNode;
};

const DialogConfirmDeletion = ({
  name,
  isPermanent,
  onDelete,
  onCancel,
  customComponent,
}: Props) => {
  const [text, setText] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };
  return (
    <Dialog maxWidth='md' fullWidth open PaperProps={{sx: {zIndex: 3}}}>
      <DialogTitle
        sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Typography sx={{textAlign: 'center', width: '100%'}}>
          Delete
        </Typography>
        <Box sx={{right: 8, top: 8}}>
          <DialogClose onClose={onCancel} />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            p: 2,
          }}>
          {customComponent}
          {isPermanent ? (
            <>
              <Typography variant='body1'>Permanently delete</Typography>
              <Box>{name}</Box>
              <Typography variant='body1'>
                You can't undo this action.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant='body1'>Delete</Typography>
              <Box>{name}</Box>
            </>
          )}
          {isPermanent && (
            <Box>
              <Typography paragraph variant='body1' pt={2}>
                To avoid accidental deletion provide additional written consent.
              </Typography>
            </Box>
          )}
          <Typography paragraph variant='body2' sx={{opacity: 0.7}}>
            {`To confirm deletion, type "DELETE" into the field.`}
          </Typography>
          <OutlinedInput
            autoFocus
            fullWidth
            value={text}
            onChange={handleChange}
            inputProps={{'aria-label': 'Confirm deletion by typing delete'}}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='contained'
          disabled={text !== 'delete'}
          onClick={onDelete}>
          Delete
        </Button>
        <Button color='primary' variant='contained' onClick={onCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmDeletion;
